import React from 'react';
import MecanicoItem from './MecanicoItem';

/**
 * Componente para mostrar una lista de mecánicos con espaciado óptimo
 * 
 * @param {Object} props - Propiedades del componente
 * @param {Array} props.mecanicos - Lista de mecánicos a mostrar
 * @param {Array} props.sucursales - Lista de sucursales disponibles
 * @param {Array} props.especialidades - Lista de especialidades disponibles
 * @param {function} props.onEdit - Función para editar un mecánico
 * @param {function} props.onSchedule - Función para gestionar horario
 * @param {function} props.onToggleActive - Función para activar/desactivar
 * @param {function} props.onDelete - Función para eliminar un mecánico
 * @returns {JSX.Element} - Componente de lista de mecánicos
 */
const MecanicosList = ({ 
  mecanicos = [], 
  sucursales = [], 
  especialidades = [],
  onEdit, 
  onSchedule, 
  onToggleActive, 
  onDelete 
}) => {
  if (mecanicos.length === 0) {
    return (
      <div className="text-center p-6 bg-gray-800 rounded-lg text-gray-400 border border-gray-700">
        <p className="mb-2">No hay mecánicos registrados.</p>
        <p className="text-sm">Agrega un nuevo mecánico para comenzar a administrar tu equipo técnico.</p>
      </div>
    );
  }

  return (
    <div>
      <ul className="space-y-3">
        {mecanicos.map(mecanico => (
          <MecanicoItem
            key={mecanico.id}
            mecanico={mecanico}
            sucursales={sucursales}
            especialidades={especialidades}
            onEdit={onEdit}
            onSchedule={onSchedule}
            onToggleActive={onToggleActive}
            onDelete={onDelete}
          />
        ))}
      </ul>
    </div>
  );
};

export default MecanicosList;